import { render } from "./EditItem2.vue?vue&type=template&id=36ac5240&scoped=true"
import script from "./EditItem2.vue?vue&type=script&lang=js"
export * from "./EditItem2.vue?vue&type=script&lang=js"

import "./EditItem2.vue?vue&type=style&index=0&id=36ac5240&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ac5240"]])

export default __exports__